import React, { Fragment, useState } from "react";

import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import QtyInput from "../../components/Reusable/QtyInput";
import QtyInputReward from "../../components/Reusable/QtyInputReward";
import { fetchRewardPost } from "../../actions/reward";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const RewardDetail = (props) => {
  const { showRewardDetail, rewardDetail, setShowRewardDetail } = props || {};

  const dispatch = useDispatch();
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  const [qtyReward, setQtyReward] = useState(1);

  const submitHandler = () => {
    setShowRewardDetail(false);
    const data = {
      rewardId: rewardDetail?.id,
      quantity: qtyReward,
    };

    dispatch(fetchRewardPost(data));
  };

  return (
    <div
      className={`reward-detail-main-container ${
        showRewardDetail ? "active" : ""
      }`}
    >
      {showRewardDetail && (
        <div className="reward-detail-content">
          <div className="reward-detail-close-icon">
            <CloseIcon onClick={() => setShowRewardDetail(false)} />
          </div>
          <div className="reward-detail-image-title-section">
            <div className="reward-detail-image">
              <img
                src={`${rewardDetail?.image}`}
                className="img-fluid"
                alt="LG OLED TV"
              />
            </div>
            <div className="reward-detail-title-content">
              <div className="reward-detail-title">{rewardDetail?.name}</div>
              <div className="reward-detail-price">
                {t("rewardDetail.pointsLabel")} {rewardDetail?.points}
              </div>
            </div>
          </div>
          <div className="reward-detail-description">
            {rewardDetail?.description && (
              <Fragment>
                {t("rewardDetail.productDescriptionLabel")}{" "}
                <div
                  dangerouslySetInnerHTML={{
                    __html: rewardDetail?.description,
                  }}
                ></div>
              </Fragment>
            )}
          </div>
          <div className="reward-detail-button">
            <QtyInputReward
              value={1}
              onChange={(newQty) => setQtyReward(newQty)}
            />
            <Button
              variant="contained"
              onClick={submitHandler}
              sx={{ textTransform: "none" }}
            >
              {t("rewardDetail.orderRewardButton")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardDetail;
